import { render } from "./PageIndexSeven.vue?vue&type=template&id=8fcec8a0"
import script from "./PageIndexSeven.vue?vue&type=script&lang=js"
export * from "./PageIndexSeven.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__